import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import DoctorView from "../components/doctorview/doctorview";

import logo from "../assets/homescreen/futurehealthlogo.svg";
import bandImage from "../assets/homescreen/bandimage.png";
import cgmImage from "../assets/homescreen/cgm.png";
import graphImage from "../assets/homescreen/graphimage.png";
import oldPeopleImage from "../assets/homescreen/oldpeopleimage.png";
import rightDoctorImage from "../assets/homescreen/Rightdoctor.png";
import saladImage from "../assets/homescreen/saladimage.png";
import programOverviewIcon from "../assets/homescreen/programoverviewlogo.svg";
import newInquiryIcon from "../assets/homescreen/newinquirylogo.svg";
import doctorOverviewIcon from "../assets/homescreen/doctoroverviewlogo.svg";

import "../styles/CCHome.css";

export default function CCHome() {
  const navigate = useNavigate();
  const [doctorOpen, setDoctorOpen] = useState(false);

  return (
    <div className="cc-home">
      {/* ── Background ── */}
      <div className="cc-home-bg">
        <div className="cc-bg-grid" />
        <div className="cc-bg-glow cc-glow-1" />
        <div className="cc-bg-glow cc-glow-2" />
      </div>

      {/* ── Floating asset collage + vitals connector ── */}
      <div className="cc-collage" aria-hidden="true">
        <svg className="cc-collage-svg" viewBox="0 0 1440 900" preserveAspectRatio="none">
          <path
            className="cc-connector-line"
            d="M 150 210 C 60 320, 60 380, 130 470
               C 180 540, 210 560, 150 640
               M 1290 190 C 1350 300, 1360 340, 1290 400
               C 1230 450, 1190 470, 1290 560"
          />
          {/* Signature vitals blip along the left path */}
          <path
            className="cc-connector-pulse"
            d="M 95 500 l 10 0 l 6 -22 l 10 40 l 8 -30 l 6 12 l 14 0"
          />
          <circle className="cc-connector-dot" cx="150" cy="210" r="4" />
          <circle className="cc-connector-dot" cx="130" cy="470" r="4" />
          <circle className="cc-connector-dot" cx="150" cy="640" r="4" />
          <circle className="cc-connector-dot" cx="1290" cy="190" r="4" />
          <circle className="cc-connector-dot" cx="1290" cy="400" r="4" />
          <circle className="cc-connector-dot" cx="1290" cy="560" r="4" />
        </svg>

        <figure className="cc-float cc-float-1">
          <img src={oldPeopleImage} alt="Elderly patient with their caregiver" />
        </figure>
        <figure className="cc-float cc-float-2">
          <img src={bandImage} alt="Wearable health monitoring band" />
        </figure>
        <figure className="cc-float cc-float-3">
          <img src={graphImage} alt="Patient health metrics graph" />
        </figure>
        <figure className="cc-float cc-float-4">
          <img src={cgmImage} alt="Continuous glucose monitor kit" />
        </figure>
        <figure className="cc-float cc-float-5">
          <img src={saladImage} alt="Balanced nutrition bowl" />
        </figure>
        <figure className="cc-float cc-float-6">
          <img src={rightDoctorImage} alt="Doctor reviewing patient records" />
        </figure>
      </div>

      {/* ── Top bar ── */}
      <header className="cc-home-topbar">
        <div className="cc-home-logo">
          <img src={logo} alt="Future Health" className="cc-logo-img" />
          <div className="cc-logo-text">
            <span className="cc-logo-title">Future Health</span>
          </div>
        </div>
      </header>

      {/* ── Main ── */}
      <main className="cc-home-main">
        <div className="cc-home-intro">
          <div className="cc-home-eyebrow">
            <span className="cc-eyebrow-dot" />
            Care Coordinator Portal
          </div>
          <h1 className="cc-home-heading">
            What would you like<br />to do today?
          </h1>
          <p className="cc-home-sub">
            Select a module to get started with your workflow.
          </p>
        </div>

        <div className="cc-cards-grid">
          {/* ── Card 1: NCD Programme ── */}
          <div
            className="cc-choice-card cc-card-teal"
            onClick={() => navigate("/care-coordinator/program")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/care-coordinator/program")}
          >
            <span className="cc-card-tag cc-tag-teal">Live</span>
            <div className="cc-card-icon-wrap cc-icon-teal">
              <img src={programOverviewIcon} alt="" className="cc-card-icon-img" />
            </div>
            <h2 className="cc-card-title">Patient Programme Overview</h2>
            <p className="cc-card-desc">
              View and manage all enrolled patients, track care journeys, phases and health metrics.
            </p>
            <div className="cc-card-footer">
              <span className="cc-card-cta">Open Programme</span>
              <span className="cc-card-arrow">→</span>
            </div>
          </div>

          {/* ── Card 2: New Inquiry Registration ── */}
          <div
            className="cc-choice-card cc-card-blue"
            onClick={() => navigate("/care-coordinator/inquiry")}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && navigate("/care-coordinator/inquiry")}
          >
            <span className="cc-card-tag cc-tag-coral">New</span>
            <div className="cc-card-icon-wrap cc-icon-blue">
              <img src={newInquiryIcon} alt="" className="cc-card-icon-img" />
            </div>
            <h2 className="cc-card-title">New Inquiry Registration</h2>
            <p className="cc-card-desc">
              Register a new patient inquiry and onboard them into the diabetes management programme.
            </p>
            <div className="cc-card-footer">
              <span className="cc-card-cta">Open Registration</span>
              <span className="cc-card-arrow">→</span>
            </div>
          </div>

          {/* ── Card 3: Doctor View ── */}
          <div
            className="cc-choice-card cc-card-violet"
            onClick={() => setDoctorOpen(true)}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && setDoctorOpen(true)}
          >
            <span className="cc-card-tag cc-tag-violet">Clinical</span>
            <div className="cc-card-icon-wrap cc-icon-violet">
              <img src={doctorOverviewIcon} alt="" className="cc-card-icon-img" />
            </div>
            <h2 className="cc-card-title">Doctor View</h2>
            <p className="cc-card-desc">
              Look up any patient by phone number. Review vitals, programme progress, and clinical data in one place.
            </p>
            <div className="cc-card-footer">
              <span className="cc-card-cta">Open Doctor View</span>
              <span className="cc-card-arrow">→</span>
            </div>
          </div>
        </div>
      </main>

      {/* ── Doctor View slide-in panel ── */}
      {doctorOpen && (
        <div className="cc-dv-overlay" onClick={() => setDoctorOpen(false)}>
          <div className="cc-dv-panel" onClick={(e) => e.stopPropagation()}>
            <div className="cc-dv-topbar">
              <div className="cc-dv-modal-title">
                <span className="cc-dv-pulse" />
                Doctor Patient Lookup
              </div>
              <button className="cc-dv-close" onClick={() => setDoctorOpen(false)}>✕</button>
            </div>
            <div className="cc-dv-body">
              <DoctorView />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}